import { render, staticRenderFns } from "./GuppyChatMessageActions.vue?vue&type=template&id=e31ef1a6&"
import script from "./GuppyChatMessageActions.vue?vue&type=script&lang=js&"
export * from "./GuppyChatMessageActions.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatMessageActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports